import { Component, input, InputSignal } from '@angular/core';

@Component({
  selector: 'im-loader',
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss',
})
export class LoaderComponent {
  public message: InputSignal<string | undefined> = input();
}
